// #1115B S9 — /projects/:id/settings/github
//
// Settings page for project-scoped GitHub repo configuration. Loaded from
// the dashboard banner's [Configure GitHub →] CTA. Renders the same
// <GitHubRepoSetupSection /> used in NewProjectModal, but in "settings
// mode" — the section owns its submit and POSTs to /projects/:id/github-repo.
// On success, redirects back to the dashboard so the user sees the banner
// disappear (V4 symmetry — same source of truth re-fetched).

import { useNavigate, useParams } from 'react-router-dom';
import GitHubRepoSetupSection, { type GitHubSetupResult } from '../components/GitHubRepoSetupSection';

export default function ProjectGithubSettingsPage() {
  // Sprint A.9 — parent route :projectId; alias preserves `id`.
  const { projectId: id } = useParams<{ projectId: string }>();
  const navigate = useNavigate();

  if (!id) return null;

  const handleComplete = (result: GitHubSetupResult) => {
    if (result.state === 'PROVISIONED' || result.state === 'SKIPPED') {
      // Both terminal states return to the dashboard. Banner shows for
      // SKIPPED (state !== 'PROVISIONED'), disappears for PROVISIONED.
      navigate(`/projects/${id}`);
    }
    // ERROR state: keep the user on this page so they can retry.
  };

  return (
    <div style={{ flex: 1, padding: '32px 48px', maxWidth: 760 }}>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>
        GitHub Repository
      </h1>
      <p style={{ fontFamily: 'var(--font-body)', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 24 }}>
        Configure how BluePrint connects this project to GitHub. Required before the Development phase can begin.
      </p>
      <GitHubRepoSetupSection
        projectId={id}
        onComplete={handleComplete}
      />
    </div>
  );
}
